﻿
(function ($, document) {

    $(document).ready(function () {

        $(document).on('click', function (e) {
            var $ddl = $('.table-action-menu');
            if (!$ddl.is(e.target) // if the target of the click isn't the container...
                && $ddl.has(e.target).length === 0) // ... nor a descendant of the container
            {
                if ($ddl.hasClass('active')) {
                    $ddl.toggleClass('active');
                }
                return;
            }

            if ($ddl.find('.table-action-menu__label').is(e.target)) {
                $ddl.toggleClass('active');
            }
        });
    });
})(jQuery, document);